export enum MessageType {
  // Incoming (from Portal)...
  userStateChange = 'userStateChange',
  tenantChange = 'tenantChange',
  keepAlive = 'keepAlive',
  getPageUrl = 'getPageUrl',
  menuItemSelect = 'menuItemSelect',
  secondaryToolbarSelect = 'secondaryToolbarSelect',
  activate = 'activate',
  passivate = 'passivate',
  redeemToken = 'redeemToken',
  destinyViewType = 'destinyViewType',

  // Outgoing (to Portal)...
  userActivityDetected = 'userActivityDetected',
  updateNavInfo = 'updateNavInfo',
  createDeepLink = 'createDeepLink',
  ready = 'ready',
  registerMenuItems = 'registerMenuItems',
  login = 'login',
  notification = 'notification',
  toast = 'toast',
  iframeMetadata = 'iframeMetadata',

  registerSecondaryToolbar = 'registerSecondaryToolbar',
  updateSecondaryToolbarBreadcrumbs = 'updateSecondaryToolbarBreadcrumbs',
  updateSecondaryToolbarButtons = 'updateSecondaryToolbarButtons',
  updateSecondaryToolbarSelects = 'updateSecondaryToolbarSelectes',

  // To/From
  appAction = 'appAction',
  activateMenuItem = 'activateMenuItem',

  // Internal types. DO NOT USE
  _auto_ack = '_ack'  /* DO NOT USE. INTERNAL USE ONLY */
}






